import React from "react";

import { Container, Overlay } from "./styles";
import { Icon20 as TodeschiniLogo } from "../../assets/todeschini";
import { Icon1 as ItalineaLogo } from "../../assets/italinea";
import { Icon8 as CriareLogo } from "../../assets/criare";

interface IProps {
  title: string;
  image: string;
  isHome?: boolean;
  superscript?: string;
  subscript?: string;
  italinea?: boolean;
  criare?: boolean;
  logo?: React.ReactNode;
}

const Hero: React.FC<IProps> = ({
  isHome = false,
  title,
  superscript,
  subscript,
  image,
  italinea,
  criare,
  logo,
}) => {
  return (
    <Container>
      <img src={image} alt="" />

      <div className="logo">
        {italinea ? (
          <ItalineaLogo />
        ) : criare ? (
          <CriareLogo />
        ) : (
          <TodeschiniLogo />
        )}
      </div>

      <Overlay isHome={isHome} italinea={italinea} criare={criare}>
        {superscript && <h2 className="superscript">{superscript}</h2>}
        <h1>{title}</h1>
        {subscript && <h2 className="subscript">{subscript}</h2>}
        {criare && <b className="bar" />}
      </Overlay>

      {logo && <div className="logo">{logo}</div>}
    </Container>
  );
};

export default Hero;
